module.exports = __webpack_public_path__ + "static/media/red_arrow.2d25a657.jpg";